// extracted by mini-css-extract-plugin
export default {"message":"H8NUPJdMADWWNvzhjMh6","success":"Hl8moqHIGho1pnDtGQY5","warning":"UObNuA6oUYkbrXwf27Xf","error":"sc5CgKnYNLlEQvWSWoZz"};